<template>
    <div>
        <div class="legals">
            <div
                class="form-group"
                :class="{error: $v.form.terms.$error}"
            >
                <label>
                    <input type="checkbox" v-model="form.terms">
                    <i18n path="subscription.payment_legals.accept.label_recurrent" tag="span">
                        <template>
                            <a :href="termsUrl" target="_blank">{{ $t('subscription.payment_legals.accept.terms') }}</a>
                        </template>
                        <template>
                            <a :href="privacyUrl" target="_blank">{{ $t('subscription.payment_legals.accept.privacy') }}</a>
                        </template>
                        <template>
                            <a :href="'mailto:' + supportAddress" target="_blank">{{ supportAddress }}</a>
                        </template>
                    </i18n>
                </label>
                <template v-if="$v.form.terms.$error">
                    <p
                        class="error-message"
                        v-if="!$v.form.terms.accepted"
                    >
                        {{$t('validations.accepted', {field: $t('fields.terms')})}}
                    </p>
                </template>
            </div>
        </div>
    
        <div class="buttons-container">
            <button
                type="button"
                class="btn main-btn submit"
                @click="payHandler"
            >
                {{$t('subscription.buttons.pay')}}
            </button>
        </div>
        <ResultMessage
            v-if="resultMessage.message"
            :result-message="resultMessage"
        />
    </div>
</template>
<script>
import resources from "../resources";
import EventBus from "../eventbus";
import {email, required, requiredIf} from "vuelidate/lib/validators";
import luhn from "luhn";
import ResultMessage from "./ResultMessage";

export default {
    components: {
        ResultMessage,
    },
    props: {
        subscriptionPlan: {
            type: Object,
            required: true
        },
        userCreditCard: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
            form: {
                terms: false,
            },
            resultMessage: false,
        };
    },
    methods: {
        payHandler(){
            if(this.$v.form.$invalid) {
                this.$v.form.$touch();
            }else{
    
                this.$emit('loadingChange', true);
                this.$http.post(`one_click_payment/${this.subscriptionPlan.id}/${this.userCreditCard.id}`, {})
                    
                    .then((resp) => {
                    setTimeout(() => {
                        this.$emit('loadingChange', false);
                        //Le damos tiempo, para que con el redirect no se vea que dejo de cargar, pero si hay un error en el redirect no rompemos el UI
                    }, 2500);
        
                    const redirect = resp.body.data.redirect;
                
                    if(redirect && redirect.url){
                        switch(redirect.method.toLowerCase()){
                            case 'get':
                            
                                window.location.href = redirect.url;
                                return;
                        
                            // case 'post':
                            //     const redirectForm = document.createElement('form');
                            //     redirectForm.setAttribute('action', redirect.url);
                            //     redirectForm.setAttribute('method', 'post');
                            //     redirectForm.setAttribute('hidden', 'true');
                            //
                            //     if(redirect.fields){
                            //         Object.keys(redirect.fields).forEach(key => {
                            //             const fieldInput = document.createElement('input');
                            //             fieldInput.setAttribute('type', 'hidden');
                            //             fieldInput.setAttribute('name', key);
                            //             fieldInput.setAttribute('value', redirect.fields[key]);
                            //             redirectForm.appendChild(fieldInput);
                            //         });
                            //     }else if(redirect.params){
                            //         Object.keys(redirect.params).forEach(key => {
                            //             const fieldInput = document.createElement('input');
                            //             fieldInput.setAttribute('type', 'hidden');
                            //             fieldInput.setAttribute('name', key);
                            //             fieldInput.setAttribute('value', redirect.params[key]);
                            //             redirectForm.appendChild(fieldInput);
                            //         });
                            //     }
                            //
                            //     document.body.appendChild(redirectForm);
                            //     redirectForm.submit();
                            //     return;
                        
                            default: throw new Error('Unknown method');
                        }
                    }else{
                        this.$router.push({name: 'dashboard'});
                    }
                
                    /*
                    this.hasToAcceptNoTrial = false;
                    this.hasToAcceptNoPromo = false;
                    */
                
                }).catch(err => {
                    this.$emit('loadingChange', false);
                
                    // this.hasToAcceptNoTrial = false;
                    // this.hasToAcceptNoPromo = false;
                
                    if(err.status === 422){
                        this.resultMessage = this.$t('subscription.messages.validation_error');
                    }else if(err.status === 409){
                        // this.hasToAcceptNoTrial = true;
                        // this.hasToAcceptNoPromo = true;
                    }else if(err.status === 410){
                        // this.hasToAcceptNoPromo = true;
                    }else{
                        this.resultMessage = this.$t('subscription.messages.server_error');
                    }
                })
            }
    
        }
    },
    computed: {
        termsUrl(){
            let langCode = this.$i18n.locale;
            return `/legals/terms/${langCode}.pdf`;
        },
        privacyUrl(){
            let langCode = this.$i18n.locale;
            return `/legals/privacy/${langCode}.pdf`;
        },
        supportAddress(){
            return `soporte@divasplay.com`;
        },
    
    },
    validations(){
        return {
            form: {
                terms: {
                    accepted(value){
                        return value === true;
                    },
                }
            }
        }
    },
    
    
}
</script>

<style scoped lang="scss">
@import './../styles/variables';
@import './../styles/classes';

.buttons-container{
    text-align: center;
    
    .submit{
        @extend %fresh-btn;
        font-size: 2em;
    }
}
</style>